import { useCallback } from "react";
import { LicensesApi, useAPIAction } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

export interface GenerateLicenseConfirmButtonInterface {
  version_id: string;
  product_code: string;
  subscription_code: string;
  referral_code: string;
  number_of_licenses: number;
  subscription_start_date?: Date | null;
}

export const useGenerateLicense = () => {
  const { t } = useTranslation();
  const [GenerateLicense] = useAPIAction(
    LicensesApi,
    async (
      api,
      GenerateActionDetails: GenerateLicenseConfirmButtonInterface
    ) => {
      let data = await api.generateSerialNumber({
        controlcenterMelcoModelsGenerateSerialNumber: {
          product_code: GenerateActionDetails.product_code,
          subscription_code: GenerateActionDetails.subscription_code,
          referral_code: GenerateActionDetails.referral_code,
          number_of_licenses: GenerateActionDetails.number_of_licenses,
          version_id: GenerateActionDetails.version_id,
          subscription_start_date:
            GenerateActionDetails.subscription_start_date,
        },
      });

      let batchNumber =
        data && data.list && data.list[0] ? data.list[0]?.batch ?? "" : "";
      return {
        successMessages: [
          {
            message: t(`licenses.basic.detail.generate.success.default`, {
              batchnumber: batchNumber,
            }),
          },
        ],
        data,
      };
    },
    { skipErrorHandling: true, translationPrefix: "" }
  );

  return useCallback(
    async (GenerateActionDetails: GenerateLicenseConfirmButtonInterface) => {
      return await GenerateLicense(GenerateActionDetails);
    },
    [GenerateLicense]
  );
};
